import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge Tailwind class names with conflict resolution.
 *
 * The library's primitives use this internally so consumer-supplied `className`
 * always wins over the default classes. Re-exported for consumers that want the
 * same merge behavior in their own code.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
